import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { selectSelectedAccount } from '@mkp/account/state';
import { Store } from '@ngrx/store';
import { Observable, filter, of, switchMap, take } from 'rxjs';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { selectWorkspaceFromUrlStatus, WorkspaceFromUrlStatus } from '@mkp/auth/state';
import { concatLatestFrom } from '@ngrx/operators';

// This Guard doesn't handle redirection when unselecting an account
// Refer to AccountProtectionService instead for this feature
@Injectable({
  providedIn: 'root',
})
export class BoAccountSelectedGuard {
  private store = inject(Store);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(selectWorkspaceFromUrlStatus).pipe(
      concatLatestFrom(() => this.store.select(selectIsBoUser)),
      filter(([state]) => state === WorkspaceFromUrlStatus.COMPLETED),
      take(1),
      switchMap(([_, isBoUser]) =>
        isBoUser
          ? this.store.select(selectSelectedAccount).pipe(
              take(1),
              switchMap((account) => (!account ? this.navigateToFallbackRoute(route) : of(true)))
            )
          : of(true)
      )
    );
  }

  navigateToFallbackRoute(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.router.navigate([getFallbackRoute(route)]);
    return of(false);
  }
}

export const getFallbackRoute = (route: ActivatedRouteSnapshot): string =>
  route.data['fallbackRoute'] ?? AppConfig.routes.home;
